import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { Users, Save, Phone, MapPin, Clock } from 'lucide-react';
import toast from 'react-hot-toast';

export default function JoinTeam() {
  const api = useApi();
  const { can } = useAuth();
  const [requests, setRequests] = useState([]);
  const [settings, setSettings] = useState({
    join_team_msg: 'Aap roz kitna waqt de sakte hain?',
    join_team_footer: 'Official Team — Allama Hassan Raza Naqshbandi',
    join_team_time_opts: '20 minute,30 minute,45 minute'
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('requests');

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    const [r, s] = await Promise.all([
      api.get('/team-requests'),
      api.get('/join-team-settings')
    ]);
    if (r?.requests) setRequests(r.requests);
    if (s?.settings) setSettings(p => ({ ...p, ...s.settings }));
    setLoading(false);
  }

  async function save() {
    setSaving(true);
    const d = await api.post('/join-team-settings', { updates: settings });
    if (d?.success) toast.success('Settings save ho gayi!');
    else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  if (loading) return (
    <div style={{ textAlign: 'center', padding: 60 }}>
      <span className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="section-title">👥 Join Team</div>
          <div className="section-sub">Team join requests aur settings manage karein</div>
        </div>
        <div style={{
          padding: '4px 12px', borderRadius: 20, fontSize: 12,
          background: 'var(--emerald-900)', border: '1px solid var(--emerald-700)',
          color: 'var(--emerald-300)'
        }}>
          {requests.length} Requests
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)', paddingBottom: 0 }}>
        {['requests', 'settings'].map(t => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              padding: '8px 16px', background: 'none', border: 'none',
              borderBottom: tab === t ? '2px solid var(--emerald-400)' : '2px solid transparent',
              color: tab === t ? 'var(--emerald-300)' : 'var(--text-muted)',
              cursor: 'pointer', fontSize: 13, fontWeight: tab === t ? 600 : 400,
              textTransform: 'capitalize', marginBottom: -1
            }}
          >
            {t === 'requests' ? `📋 Requests (${requests.length})` : '⚙️ Settings'}
          </button>
        ))}
      </div>

      {tab === 'requests' && (
        <>
          {requests.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>
              <Users size={32} style={{ marginBottom: 12, opacity: 0.4 }} />
              <div>Abhi koi team join request nahi hai</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {requests.map((r, i) => (
                <div key={i} className="card" style={{ padding: '14px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: '50%',
                      background: 'var(--emerald-800)', border: '1px solid var(--emerald-600)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 14, color: 'var(--emerald-300)', fontWeight: 600, flexShrink: 0
                    }}>
                      {(r.name || '?')[0]?.toUpperCase()}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 13, color: 'var(--text-primary)' }}>
                        {r.name || 'N/A'}
                      </div>
                      <div style={{ display: 'flex', gap: 12, marginTop: 3, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 11, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Phone size={10} /> +{r.phone}
                        </span>
                        <span style={{ fontSize: 11, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 4 }}>
                          <MapPin size={10} /> {r.city || 'N/A'}
                        </span>
                        <span style={{ fontSize: 11, color: 'var(--text-muted)', display: 'flex', alignItems: 'center', gap: 4 }}>
                          <Clock size={10} /> {new Date(r.created_at).toLocaleDateString('ur-PK')}
                        </span>
                      </div>
                    </div>
                    <a
                      href={`https://wa.me/${r.phone}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary btn-sm"
                      style={{ fontSize: 11 }}
                    >
                      💬 WhatsApp
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {tab === 'settings' && (
        <div style={{ maxWidth: 560 }}>
          <div className="card">
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 20 }}>
              ⚙️ Join Team Bot Message Settings
            </div>

            <div className="field">
              <label className="label">Bot ka Message (user ko yeh dikhega)</label>
              <textarea
                className="textarea"
                value={settings.join_team_msg}
                onChange={e => setSettings(p => ({ ...p, join_team_msg: e.target.value }))}
                disabled={!can('settings')}
                style={{ minHeight: 80 }}
              />
            </div>

            <div className="field">
              <label className="label">Footer Text</label>
              <input
                className="input"
                value={settings.join_team_footer}
                onChange={e => setSettings(p => ({ ...p, join_team_footer: e.target.value }))}
                disabled={!can('settings')}
              />
            </div>

            <div className="field">
              <label className="label">Time Options (comma se alag karain)</label>
              <input
                className="input"
                value={settings.join_team_time_opts}
                onChange={e => setSettings(p => ({ ...p, join_team_time_opts: e.target.value }))}
                disabled={!can('settings')}
                placeholder="20 minute,30 minute,45 minute"
              />
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
                Max 3 options (WhatsApp buttons ki limit)
              </div>
            </div>

            {can('settings') && (
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
                {saving ? ' Saving...' : ' Save Karein'}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}